/**
 * This file was generated via the command "npx vue-auth0-generate-permissions"
 * Do not make changes to this file directly
 */
import { computed, ComputedRef } from "vue";

import useAuthentication from "./use-authentication";

const { permissions } = useAuthentication();

interface Authorizations {
  canReadGames: ComputedRef<boolean>;
  canReadClasses: ComputedRef<boolean>;
  canReadFeatures: ComputedRef<boolean>;
  canReadSegments: ComputedRef<boolean>;
  canReadConfigurations: ComputedRef<boolean>;
  canReadAbtests: ComputedRef<boolean>;
  canReadTesters: ComputedRef<boolean>;
  canReadSandboxes: ComputedRef<boolean>;
  canWriteGames: ComputedRef<boolean>;
  canWriteVersions: ComputedRef<boolean>;
  canWriteClasses: ComputedRef<boolean>;
  canWriteFeatures: ComputedRef<boolean>;
  canWriteSegments: ComputedRef<boolean>;
  canWriteConfigurations: ComputedRef<boolean>;
  canWriteAbtests: ComputedRef<boolean>;
  canWriteTesters: ComputedRef<boolean>;
  canReadActionlogs: ComputedRef<boolean>;
  canAccessApi: ComputedRef<boolean>;
  canWriteClassesCatalog: ComputedRef<boolean>;
  canReadClassesCatalog: ComputedRef<boolean>;
  canAccessAppcues: ComputedRef<boolean>;
  canReadVersions: ComputedRef<boolean>;
  canReadFeaturesCatalog: ComputedRef<boolean>;
  canWriteFeaturesCatalog: ComputedRef<boolean>;
  canReadVersionsMetadata: ComputedRef<boolean>;
  canReadDebuggerMetadata: ComputedRef<boolean>;
  canWriteSandboxes: ComputedRef<boolean>;
  canAccessAllApps: ComputedRef<boolean>;
  canDeleteGames: ComputedRef<boolean>;
}

const hasPermission = (permission: string) => permissions.value?.includes(permission) || false;

export default function usePermissions(): Authorizations {
  const canReadGames = computed(() => hasPermission("read:games"));
  const canReadClasses = computed(() => hasPermission("read:classes"));
  const canReadFeatures = computed(() => hasPermission("read:features"));
  const canReadSegments = computed(() => hasPermission("read:segments"));
  const canReadConfigurations = computed(() => hasPermission("read:configurations"));
  const canReadAbtests = computed(() => hasPermission("read:abtests"));
  const canReadTesters = computed(() => hasPermission("read:testers"));
  const canReadSandboxes = computed(() => hasPermission("read:sandboxes"));
  const canWriteGames = computed(() => hasPermission("write:games"));
  const canWriteVersions = computed(() => hasPermission("write:versions"));
  const canWriteClasses = computed(() => hasPermission("write:classes"));
  const canWriteFeatures = computed(() => hasPermission("write:features"));
  const canWriteSegments = computed(() => hasPermission("write:segments"));
  const canWriteConfigurations = computed(() => hasPermission("write:configurations"));
  const canWriteAbtests = computed(() => hasPermission("write:abtests"));
  const canWriteTesters = computed(() => hasPermission("write:testers"));
  const canReadActionlogs = computed(() => hasPermission("read:actionlogs"));
  const canAccessApi = computed(() => hasPermission("access:api"));
  const canWriteClassesCatalog = computed(() => hasPermission("write:classes_catalog"));
  const canReadClassesCatalog = computed(() => hasPermission("read:classes_catalog"));
  const canAccessAppcues = computed(() => hasPermission("access:appcues"));
  const canReadVersions = computed(() => hasPermission("read:versions"));
  const canReadFeaturesCatalog = computed(() => hasPermission("read:features_catalog"));
  const canWriteFeaturesCatalog = computed(() => hasPermission("write:features_catalog"));
  const canReadVersionsMetadata = computed(() => hasPermission("read:versions_metadata"));
  const canReadDebuggerMetadata = computed(() => hasPermission("read:debugger_metadata"));
  const canWriteSandboxes = computed(() => hasPermission("write:sandboxes"));
  const canAccessAllApps = computed(() => hasPermission("access:all_apps"));
  const canDeleteGames = computed(() => hasPermission("delete:games"));

  return {
    canReadGames,
    canReadClasses,
    canReadFeatures,
    canReadSegments,
    canReadConfigurations,
    canReadAbtests,
    canReadTesters,
    canReadSandboxes,
    canWriteGames,
    canWriteVersions,
    canWriteClasses,
    canWriteFeatures,
    canWriteSegments,
    canWriteConfigurations,
    canWriteAbtests,
    canWriteTesters,
    canReadActionlogs,
    canAccessApi,
    canWriteClassesCatalog,
    canReadClassesCatalog,
    canAccessAppcues,
    canReadVersions,
    canReadFeaturesCatalog,
    canWriteFeaturesCatalog,
    canReadVersionsMetadata,
    canReadDebuggerMetadata,
    canWriteSandboxes,
    canAccessAllApps,
    canDeleteGames,
  };
}
